var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#E02126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.48 7.86035H2.52002C2.11002 7.86035 1.77002 7.52035 1.77002 7.11035C1.77002 6.70035 2.10002 6.36035 2.52002 6.36035H21.48C21.89 6.36035 22.23 6.70035 22.23 7.11035C22.23 7.52035 21.9 7.86035 21.48 7.86035Z",
    fill: "#E02126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52002 7.72035C8.11002 7.72035 7.77002 7.38035 7.77002 6.97035V2.11035C7.77002 1.70035 8.11002 1.36035 8.52002 1.36035C8.93002 1.36035 9.27002 1.70035 9.27002 2.11035V6.97035C9.27002 7.38035 8.93002 7.72035 8.52002 7.72035Z",
    fill: "#E02126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 7.27035C15.07 7.27035 14.73 6.93035 14.73 6.52035V2.11035C14.73 1.70035 15.07 1.36035 15.48 1.36035C15.89 1.36035 16.23 1.70035 16.23 2.11035V6.52035C16.23 6.94035 15.9 7.27035 15.48 7.27035Z",
    fill: "#E02126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 18.1203C10.73 18.1203 10.39 18.0303 10.08 17.8603C9.4 17.4603 9 16.6603 9 15.6503V13.2503C9 12.2403 9.4 11.4303 10.09 11.0303C10.78 10.6303 11.68 10.6903 12.55 11.2003L14.63 12.4003C15.5 12.9003 16.01 13.6503 16.01 14.4503C16.01 15.2503 15.5 16.0003 14.62 16.5003L12.54 17.7003C12.06 17.9803 11.56 18.1203 11.09 18.1203ZM11.1 12.2703C11 12.2703 10.91 12.2903 10.84 12.3303C10.63 12.4503 10.5 12.7903 10.5 13.2503V15.6503C10.5 16.1003 10.63 16.4403 10.84 16.5703C11.05 16.6903 11.41 16.6303 11.8 16.4003L13.88 15.2003C14.27 14.9703 14.51 14.6903 14.51 14.4503C14.51 14.2103 14.28 13.9303 13.88 13.7003L11.8 12.5003C11.54 12.3503 11.29 12.2703 11.1 12.2703Z",
    fill: "#E02126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.7911f4aee1677e4b31c2d2a2afca8d59.svg";
export { ForwardRef as ReactComponent };